import { render, staticRenderFns } from "./select-area.vue?vue&type=template&id=21c63b81"
import script from "./select-area.vue?vue&type=script&lang=js"
export * from "./select-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports